import { type ImageKey } from '@/assets/img/imageMap';
import { type TicketRewardType } from '@/common/types/lottery';

const getRewardIconKey = (
  type: 'tgem' | 'dice' | 'usd' | 'usdt' | TicketRewardType,
): ImageKey => {
  const tickets = ['diamondTicket', 'goldTicket', 'silverTicket'];

  if (tickets.includes(type)) {
    return (type + '3d') as
      | 'silverTicket3d'
      | 'goldTicket3d'
      | 'diamondTicket3d';
  }

  if (type === 'usdt') {
    return 'usd';
  }

  return type;
};

export { getRewardIconKey };
